import { useCallback, useMemo } from 'react';
import { Table, TableRow, TableRowActionsCell } from 'altus-ui-components';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { fromJS } from 'immutable';
import { EMPTY_MAP } from 'app/app.constants';
import { formatValue } from 'utils/format.util';

const SchematicTable = ({
  onRowClick,
  data,
  onEdit,
  onDelete,
  lengthUnit,
  widthUnit,
  isEdit,
}) => {
  const columns = useMemo(() => {
    const columns = [
      {
        xs: 2,
        Header: 'Name',
        accessor: (schematicComponent) => schematicComponent.get('name'),
      },
      {
        xs: 2,
        Header: 'Description',
        accessor: (schematicComponent) => schematicComponent.get('description'),
      },
      {
        xs: 2,
        Header: `Start Depth (${lengthUnit})`,
        accessor: (schematicComponent) =>
          formatValue(schematicComponent.get('from'), '', 0.01),
      },
      {
        xs: 2,
        Header: `End Depth (${lengthUnit})`,
        accessor: (schematicComponent) =>
          formatValue(schematicComponent.get('to'), '', 0.01),
      },
      {
        xs: 2,
        Header: `Inner Diameter (${widthUnit})`,
        accessor: (schematicComponent) =>
          formatValue(schematicComponent.get('inner'), '', 0.01),
      },
      {
        xs: 2,
        Header: `Outer Diameter (${widthUnit})`,
        accessor: (schematicComponent) =>
          formatValue(schematicComponent.get('outer'), '', 0.01),
      },
      {
        id: 'actions',
        Header: <TableRowActionsCell minItems={2} />,
        Cell: ({ row }) => {
          return (
            <TableRowActionsCell minItems={2}>
              <IconButton title="Edit" onClick={() => onEdit(row.index)}>
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton title="Delete" onClick={() => onDelete(row.index)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </TableRowActionsCell>
          );
        },
      },
    ];

    if (!isEdit) {
      columns.pop();
    }

    return columns;
  }, [onEdit, onDelete, lengthUnit, widthUnit, isEdit]);

  const mappedData = data?.map(({ name, data }) => {
    const { description, geometry } = data;
    const { depth, diameter } = geometry;
    return {
      name,
      description,
      from: depth.from,
      to: depth.to,
      inner: diameter.inner,
      outer: diameter.outer,
    };
  });

  const renderTableRowComponent = useCallback(
    (props) => (
      <TableRow
        {...props}
        isSelected={props.row.index === 3 ? true : false}
        onRowClick={() => onRowClick(props.row.index)}
      />
    ),
    //eslint-disable-next-line
    [],
  );

  return (
    <Table
      items={mappedData ? fromJS(mappedData) : EMPTY_MAP}
      columns={columns}
      useGlobalFilter={false}
      TableRowComponent={renderTableRowComponent}
    />
  );
};

export default SchematicTable;
